import useGetUserProfile from "../hooks/useGetUserProfile";
import Spinner from "./Spinner";
import {ReactComponent as ImageNotFound} from "../images/image-default.svg";
import {useAppContext} from "../context/AppContext";
import {jwtDecode} from "jwt-decode";

type AvatarProps = {
  isExpanded: boolean;
};

const Avatar = ({isExpanded}: AvatarProps) => {
  const {token} = useAppContext();
  const {userProfileData, isLoading} = useGetUserProfile();

  const isTokenExpired = (token: string | null) => {
    if (!token) return true;
    try {
      const payload: {exp: number} = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000);
      return payload.exp < now;
    } catch {
      return true;
    }
  };

  const showImage = !!userProfileData?.profileImage && !isTokenExpired(token);

  if (isLoading) {
    return (
      <div className="iris-avatar-sidebar-blk iris-flex-box-blk">
        <Spinner variant="small-spinner" alignSpin="center-spinner" />
      </div>
    );
  }

  return (
    <div className="iris-avatar-sidebar-blk iris-flex-box-blk">
      {showImage ? (
        <img
          src={userProfileData.profileImage}
          alt="User avatar"
          className="iris-avatar-img"
        />
      ) : (
        <ImageNotFound className="iris-avatar-img" />
      )}

      {isExpanded && (
        <p className="iris-avatar-name-blk active">
          {userProfileData?.firstName} {userProfileData?.lastName}
        </p>
      )}
    </div>
  );
};

export default Avatar;
